import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import { starfishMediaType } from 'utils/types';
import useStarfishAPI from "../hooks/useStarfishAPI";
import css from "./ConnectionList.scss";
import Connection from "./Connection";
import { isEmpty } from 'lodash';
import LoadingScreen from "./LoadingScreen";
import ErrorScreen from "./ErrorScreen";
import useDashboardError from "./useDashboardError";
import { formatPhoneNumber } from 'utils/formatter';

const isLastConnection = (connectionIndex, totalConnections) => connectionIndex === totalConnections - 1

const ConnectionList = (props) => {
    const [response, callConnectionAPI] = useStarfishAPI({isNewAPI: true});

    useEffect(() => {
        callConnectionAPI(
            `../api/starfish/success-network/connections`,
            {
                method: "GET",
                headers: {
                    'Accept': starfishMediaType('successnetwork')
                }
            })
    }, []);

    useEffect(() => {
        if (response.success) props.setCount(response.data.connections.length);
    }, [response]);

    useDashboardError(response, props.setError)

    const containerClasses = [css.content];
    if ( response.success && response.data.connections.length ) containerClasses.push(css.border);

    const getContent = () => {
        if (response.pending) return <LoadingScreen/>
        if (response.error) return <ErrorScreen/>
        if (response.success && isEmpty(response.data.connections)) return "You do not currently have any connections.";
        if (response.success && !isEmpty(response.data.connections))
            return response.data.connections.map(
              (connection, connectionIndex) =>
                    <Connection
                        key={connection.uuid}
                        personId={connection.personId}
                        uuid={connection.uuid}
                        fullName={connection.fullName}
                        email={connection.email}
                        phoneNumber={formatPhoneNumber(connection.phoneNumber)}
                        roles={connection.roles}
                        onlineSchedulingAvailable={connection.onlineSchedulingAvailable}
                        photoAvailable={connection.photoAvailable}
                        title={connection.title}
                        upward={isLastConnection(connectionIndex, response.data.connections.length)}
                    />
            );
    };

     return (
         <div className={containerClasses.join(" ")}>
             {getContent()}
         </div>
     );
};

ConnectionList.propTypes = {
    setCount: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired
};

export default ConnectionList;

